import { useRef, useEffect, useMemo } from 'react'

export function useCallbackRef<T extends (...args: any[]) => any>(callback: T): T {
  const callbackRef = useRef<T>(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  return useMemo(() => ((...args: Parameters<T>): ReturnType<T> => callbackRef.current?.(...args)) as T, [])
}
